import { render, staticRenderFns } from "./spike-conf.vue?vue&type=template&id=97f38d86&scoped=true&"
import script from "./spike-conf.vue?vue&type=script&lang=js&"
export * from "./spike-conf.vue?vue&type=script&lang=js&"
import style0 from "./spike-conf.vue?vue&type=style&index=0&id=97f38d86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f38d86",
  null
  
)

export default component.exports